import styled from "@emotion/styled";
import { Card, CardContent } from "@mui/material";


export const CardItem = styled(Card, {
  shouldForwardProp: (prop) => prop !== 'cardfilter'
})<{ cardfilter?: boolean }>(({ theme, cardfilter }) => ({
  backgroundColor: cardfilter ? '#FCFAFF' : '#FCFCFD',
  width: '100%',
  borderRadius: '12px 12px 0 0',
  borderBottom: cardfilter ? '5px solid #7F56D9' : '5px solid #FCFCFD',
  transition: 'all 0.3s ease',
  cursor: 'pointer',
}));

export const CardContentStyled = styled(CardContent)(({ theme }) => ({
  padding: '2 0 2 0',
  pb: 0,
}));